import { getFormattedCosts, formatDefaultDate } from '@/utils'
import ColumnHeader from '@/components/experience/column-header'
import TextContent from '@/components/experience/text-content'

const getEmptyCellRenderer = prop => {
  return (h, params) => {
    return params.row[prop]
      ? h('span', params.row[prop])
      : h('span', {
        class: 'ms-danger',
        domProps: {
          innerHTML: 'Не указано'
        }
      })
  }
}

export const columns = [
  {
    title: '№',
    key: 'index',
    width: 60,
    align: 'center',
    fixed: 'left'
  },
  {
    title: 'Наименование объекта',
    key: 'name',
    width: 300,
    fixed: 'left',
    align: 'center'
  },
  {
    title: 'Шифр объекта',
    key: 'code',
    width: 200,
    align: 'center'
  },
  {
    title: 'Статус',
    key: 'contract_status_name',
    width: 120,
    align: 'center'
  },
  {
    title: 'Заказчик',
    key: 'customer_description',
    width: 224,
    align: 'center',
    className: 'custom-filter',
    renderHeader (h, params) {
      return h(ColumnHeader, {
        props: {
          field: 'customer_name',
          type: 'select',
          ...params
        }
      })
    }
  },
  {
    title: 'Группа компаний',
    key: 'customer_group_name',
    width: 224,
    align: 'center',
    className: 'custom-filter',
    renderHeader (h, params) {
      return h(ColumnHeader, {
        props: {
          field: 'customer_group_name',
          type: 'select',
          ...params
        }
      })
    }
  },
  {
    title: 'Исполнитель',
    key: 'performer_name',
    width: 224,
    align: 'center'
  },
  {
    title: 'Тип проектировщика',
    key: 'planer_type',
    width: 212,
    align: 'center',
    renderHeader (h, params) {
      return h(ColumnHeader, {
        props: {
          field: 'planer_type',
          type: 'select',
          ...params
        }
      })
    },
    render: getEmptyCellRenderer('planer_type')
  },
  {
    title: 'Стадия проекта',
    key: 'project_stage_name',
    align: 'center',
    width: 212,
    renderHeader (h, params) {
      return h(ColumnHeader, {
        props: {
          field: 'project_stage_name',
          type: 'select',
          ...params
        }
      })
    },
    render: getEmptyCellRenderer('project_stage_name')
  },
  {
    title: 'Договор',
    key: 'contract_string',
    align: 'center',
    width: 200
  },
  {
    title: 'Акты',
    key: 'act_string',
    align: 'center',
    width: 200
  },
  {
    title: 'Объем изыскательских работ',
    key: 'costs',
    align: 'center',
    width: 240,
    render: (h, params) => {
      return h('span', getFormattedCosts(params.row.costs, true))
    },
    renderHeader (h, params) {
      return h(ColumnHeader, {
        props: {
          field: 'costs',
          type: 'number',
          ...params
        }
      })
    }
  },
  {
    title: 'Общая сумма по Договору (по актам)',
    key: 'signed_act_costs',
    align: 'center',
    width: 240,
    render: (h, params) => {
      return h('span', getFormattedCosts(params.row.signed_act_costs, true))
    },
    renderHeader (h, params) {
      return h(ColumnHeader, {
        props: {
          field: 'signed_act_costs',
          type: 'number',
          ...params
        }
      })
    }
  },
  {
    title: 'Общая сумма по Договору (по факт. оплатам)',
    key: 'payments_value',
    align: 'center',
    width: 240,
    render: (h, params) => {
      return h('span', getFormattedCosts(params.row.payments_value, true))
    },
    renderHeader (h, params) {
      return h(ColumnHeader, {
        props: {
          field: 'payments_value',
          type: 'number',
          ...params
        }
      })
    }
  },
  {
    title: 'Общая сумма для Субподряда',
    key: 'contragent_costs',
    align: 'center',
    width: 240,
    render: (h, params) => {
      return h('span', getFormattedCosts(params.row.contragent_costs, true))
    },
    renderHeader (h, params) {
      return h(ColumnHeader, {
        props: {
          field: 'contragent_costs',
          type: 'number',
          ...params
        }
      })
    }
  },
  {
    title: 'Дата начала',
    key: 'start_date',
    align: 'center',
    width: 150,
    render: (h, params) => {
      return h('span', formatDefaultDate(params.row.start_date))
    }
  },
  {
    title: 'Дата окончания',
    key: 'end_date',
    align: 'center',
    width: 150,
    render: (h, params) => {
      return h('span', formatDefaultDate(params.row.end_date))
    }
  },
  {
    title: 'Год заключения Договора',
    key: 'contract_start_year',
    align: 'center',
    width: 220,
    className: 'custom-filter',
    renderHeader (h, params) {
      return h(ColumnHeader, {
        props: {
          field: 'contract_start_year',
          type: 'select',
          ...params
        }
      })
    }
  },
  {
    title: 'Год завершения Договора',
    key: 'contract_end_year',
    align: 'center',
    width: 220,
    className: 'custom-filter',
    renderHeader (h, params) {
      return h(ColumnHeader, {
        props: {
          field: 'contract_end_year',
          type: 'select',
          ...params
        }
      })
    }
  },
  {
    title: 'Тип объекта',
    key: 'object_type_name',
    align: 'center',
    width: 160,
    renderHeader (h, params) {
      return h(ColumnHeader, {
        props: {
          field: 'object_type_name',
          type: 'select',
          ...params
        }
      })
    },
    render: getEmptyCellRenderer('object_type_name')
  },
  {
    title: 'Регион выполнения работ',
    key: 'work_region',
    align: 'center',
    width: 150,
    render: getEmptyCellRenderer('work_region')
  },
  {
    title: 'Федеральный округ',
    key: 'federal_district_name',
    align: 'center',
    width: 196,
    className: 'custom-filter',
    renderHeader (h, params) {
      return h(ColumnHeader, {
        props: {
          field: 'federal_district_name',
          type: 'select',
          ...params
        }
      })
    },
    render: getEmptyCellRenderer('federal_district_name')
  },
  {
    title: 'Регион выполнения работ (профильный)',
    key: 'profile_work_region_name',
    align: 'center',
    width: 196,
    className: 'custom-filter',
    renderHeader (h, params) {
      return h(ColumnHeader, {
        props: {
          field: 'profile_work_region_name',
          type: 'select',
          ...params
        }
      })
    },
    render: getEmptyCellRenderer('profile_work_region_name')
  },
  {
    title: 'Типы территории',
    key: 'territory_types',
    align: 'center',
    width: 196,
    className: 'custom-filter',
    renderHeader (h, params) {
      return h(ColumnHeader, {
        props: {
          field: 'territory_types',
          type: 'select',
          ...params
        }
      })
    },
    render: getEmptyCellRenderer('territory_types')
  },
  {
    title: 'Климатические условия',
    key: 'climate_condition_name',
    align: 'center',
    width: 196,
    className: 'custom-filter',
    renderHeader (h, params) {
      return h(ColumnHeader, {
        props: {
          field: 'climate_condition_name',
          type: 'select',
          ...params
        }
      })
    },
    render: getEmptyCellRenderer('climate_condition_name')
  },
  {
    title: 'Виды работ',
    key: 'job_types',
    align: 'center',
    width: 196,
    className: 'custom-filter',
    renderHeader (h, params) {
      return h(ColumnHeader, {
        props: {
          field: 'job_types',
          type: 'select',
          ...params
        }
      })
    }
  },
  {
    title: 'Уровень ответственности объекта',
    key: 'responsibility_level_name',
    align: 'center',
    width: 196,
    className: 'custom-filter',
    renderHeader (h, params) {
      return h(ColumnHeader, {
        props: {
          field: 'responsibility_level_name',
          type: 'select',
          ...params
        }
      })
    },
    render: getEmptyCellRenderer('responsibility_level_name')
  },
  {
    title: 'Применение СТУ',
    key: 'special_tech_conditions',
    align: 'center',
    width: 160,
    render: (h, params) => {
      return h('span', params.row.special_tech_conditions ? 'Уникальный' : 'Нет')
    },
    className: 'custom-filter',
    renderHeader (h, params) {
      return h(ColumnHeader, {
        props: {
          field: 'special_tech_conditions',
          type: 'select',
          ...params
        }
      })
    }
  },
  {
    title: 'Наличие отзыва',
    key: 'review_exists',
    align: 'center',
    width: 160,
    render: (h, params) => {
      return h('span', params.row.review_exists ? 'Да' : 'Нет')
    },
    className: 'custom-filter',
    renderHeader (h, params) {
      return h(ColumnHeader, {
        props: {
          field: 'review_exists',
          type: 'select',
          ...params
        }
      })
    }
  },
  {
    title: 'Наличие заключения',
    key: 'expert_exists',
    align: 'center',
    width: 160,
    render: (h, params) => {
      return h('span', params.row.expert_exists ? params.row.expert_data : 'Нет')
    },
    className: 'custom-filter',
    renderHeader (h, params) {
      return h(ColumnHeader, {
        props: {
          field: 'expert_exists',
          type: 'select',
          request: 'objectInfo/job_types',
          ...params
        }
      })
    }
  },
  {
    title: 'Тип тендера',
    key: 'tender_type_name',
    align: 'center',
    width: 150,
    className: 'custom-filter',
    renderHeader (h, params) {
      return h(ColumnHeader, {
        props: {
          field: 'tender_type_name',
          type: 'select',
          ...params
        }
      })
    },
    render: getEmptyCellRenderer('tender_type_name')
  },
  {
    title: 'Ссылка на закупку',
    key: 'tender_link',
    align: 'center',
    width: 200,
    render: (h, params) => {
      return params.row.tender_link && params.row.tender_link !== '-'
        ? h('a', {
          class: {
            'ms-link': true
          },
          attrs: {
            href: params.row.tender_link,
            target: '_blank'
          },
          domProps: {
            innerHTML: 'Перейти'
          }
        })
        : h('span', {
          class: 'ms-danger',
          domProps: {
            innerHTML: 'Не указано'
          }
        })
    }
  },
  {
    title: 'Примечание',
    key: 'description',
    align: 'center',
    width: 300,
    render: (h, params) => {
      return h(TextContent, {
        props: {
          content: params.row.description
        }
      })
    }
  },
  {
    title: '...',
    slot: 'action',
    width: 60,
    align: 'center',
    fixed: 'right'
  }
]
